<template>
  <footer>
    <div class="copy">
      {{ $t("terms1") }}
      <a href="https://wyniki-online.pl">wyniki-online.pl</a> {{ $t("terms2") }}
      <a href="https://agii.eu" target="_blank" rel="noopener noreferrer">Rally &amp; Communication</a>
      © 2006-{{ new Date().getFullYear() }}<br />
      {{ $t("terms3") }}

      <div class="cookies">
        <button v-if="!$route.meta.display" type="button" @click="openCookieSettings">
          {{ $t("cookiesSettings") }}
        </button>
      </div>
    </div>

    <a v-if="!$route.meta.display" href="https://agii.eu/" class="logo"><img src="/agii.png" alt="" /></a>
    <span v-else class="logo"><img src="/agii.png" alt="" /></span>
  </footer>
</template>

<script>
import { setStatus } from "@/cookieConsent"

export default {
  name: "Footer",

  methods: {
    // Czyścimy decyzję, więc belka zgody pokazuje się od nowa.
    openCookieSettings() {
      setStatus(null)
    },
  },
}
</script>

<style scoped lang="scss">
footer {
  flex-grow: 0;
  font-size: 0.65rem;
  padding: 2rem 1.5rem;
  border-top: 1px solid darken($light, 10%);
  text-align: center;

  @media (min-width: 900px) {
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

a {
  color: #000;

  &:hover {
    text-decoration: underline;
  }
}

.logo {
  margin: 1rem;
  display: inline-block;
  max-width: 10rem;

  img {
    width: 100%;
  }
}

.contact {
  margin-top: 0.5rem;
}

.cookies {
  margin-top: 0.5rem;

  button {
    color: #000;
    font-size: inherit;
    text-decoration: underline;
  }
}
</style>
